var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirport02 = function SvgAirport02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "airport-02_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#airport-02_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.395 5.42a3.867 3.867 0 0 0-3.207 1.202l-1.844 1.993-5.237-2.291a.908.908 0 0 0-1.003.186l-.88.88 5.002 3.54-3.355 3.628-2.142-.482a.403.403 0 0 0-.384.112l-.78.78 2.947 1.758 1.758 2.947.78-.78c.1-.1.149-.247.111-.384l-.482-2.142 3.628-3.355 3.54 5.001.88-.88a.908.908 0 0 0 .186-1.003l-2.302-5.25 1.993-1.844a3.803 3.803 0 0 0 1.213-3.194.475.475 0 0 0-.421-.422h-.001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "airport-02_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgAirport02 as ReactComponent };